import { CurrentUser } from './types';

export const defaultCurrentUser: CurrentUser = {
  id: '',
  username: '',
  isAdult: false,
  speedMode: false,
};
